import React from "react";
import { Card, Row, Col, FormCheckbox } from "../../components/ui";
import Photo from "../common/notif-grid-table/photo";
import {
  getNotificationPreference,
  setNotificationPreference,
} from "../../api";
import publisherStore from "../../flux/publisherStore";

const platforms = {
  email: 1,
  platform: 3,
};

class NotificationsTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      profile: JSON.parse(localStorage.getItem("user")),
    };
  }

  componentDidMount = async () => {
    let user;
    if (localStorage.getItem("user") !== null) {
      user = JSON.parse(localStorage.getItem("user"));
      const preferencesRes = await getNotificationPreference(user.id);
      this.setState({
        preferences: preferencesRes.data,
      });
    }
  };

  togglePref = async (analystId, platform, hasItem, type) => {
    let user = JSON.parse(localStorage.getItem("user"));
    let temp = this.state.preferences;
    if (hasItem) {
      let el = temp[type].filter(
        (p) =>
          p.notificationChannelId === platforms[platform] &&
          p.publisherId === analystId
      )[0];
      temp[type] = temp[type].filter((p) => p !== el);
    } else {
      temp[type].push({
        publisherId: analystId,
        notificationChannelId: platforms[platform],
      });
    }
    setNotificationPreference(user.id, temp);
    this.setState({
      preferences: temp,
    });
  };

  changeAlertsImTracking = (platform, hasItem) => {
    let user = JSON.parse(localStorage.getItem("user"));
    let temp = this.state.preferences;
    if (!hasItem) {
      temp.special["alertsImTracking"].push({
        notificationChannelId: platforms[platform],
      });
    } else {
      temp.special["alertsImTracking"] = temp.special[
        "alertsImTracking"
      ].filter((p) => p.notificationChannelId !== platforms[platform]);
    }
    setNotificationPreference(user.id, temp);
    this.setState({
      preferences: temp,
    });
  };

  changePostReplies = (platform, hasItem) => {
    let user = JSON.parse(localStorage.getItem("user"));
    let temp = this.state.preferences;
    if (!hasItem) {
      temp.special["commentReply"].push({
        notificationChannelId: platforms[platform],
      });
    } else {
      temp.special["commentReply"] = temp.special["commentReply"].filter(
        (p) => p.notificationChannelId !== platforms[platform]
      );
    }
    setNotificationPreference(user.id, temp);
    this.setState({
      preferences: temp,
    });
  };

  render() {
    const analysts = publisherStore.getPublishers();
    let alertsImTrackingHasEmail, alertsImTrackingHasPlatform;
    let publisherPostRepliesHasEmail, publisherPostRepliesHasPlatform;
    if (this.state.preferences) {
      const alertsImTracking =
        this.state.preferences.special.alertsImTracking.map(
          (p) => p.notificationChannelId
        );
      alertsImTrackingHasEmail = alertsImTracking.indexOf(1) !== -1;
      alertsImTrackingHasPlatform = alertsImTracking.indexOf(3) !== -1;
      const publisherPostReplies =
        this.state.preferences.special.commentReply.map(
          (p) => p.notificationChannelId
        );
      publisherPostRepliesHasEmail = publisherPostReplies.indexOf(1) !== -1;
      publisherPostRepliesHasPlatform = publisherPostReplies.indexOf(3) !== -1;
    }
    return (
      <React.Fragment>
        <Card small className="mb-4 p-4 notif">
          <Row>
            <Col>
              <div className="notif-grid-table">
                <div className="notif-grid-table-headers">
                  <span>Analyst</span>
                  <span>Posts</span>
                  <span>Alerts</span>
                </div>
                <div className="notif-grid-table-small-headers">
                  <span>Name</span>
                  <div className="grid-col">
                    <span>Email</span>
                    <span>Platform</span>
                  </div>
                  <div className="grid-col">
                    <span>Email</span>
                    <span>Platform</span>
                  </div>
                </div>
                {this.state.preferences &&
                  analysts
                    .filter((p) => p.isHidden === false)
                    .map((user) => {
                      let publisherAlertPreference =
                        this.state.preferences.alerts
                          .filter((p) => p.publisherId === user.id)
                          .map((p) => p.notificationChannelId);
                      let alertHasEmail =
                        publisherAlertPreference.indexOf(1) !== -1;
                      let alertHasPlatform =
                        publisherAlertPreference.indexOf(3) !== -1;
                      let publisherPostPreference = this.state.preferences.posts
                        .filter((p) => p.publisherId === user.id)
                        .map((p) => p.notificationChannelId);
                      let postHasEmail =
                        publisherPostPreference.indexOf(1) !== -1;
                      let postHasPlatform =
                        publisherPostPreference.indexOf(3) !== -1;

                      return (
                        <div className="notif-grid-table-item">
                          <div className="table-user-data">
                            <Photo
                              avatar={user.avatar.small}
                              name={user.name}
                            />
                            <span className="name">{user.name}</span>
                          </div>
                          <div className="grid-col">
                            <FormCheckbox
                              onChange={() =>
                                this.togglePref(
                                  user.id,
                                  "email",
                                  postHasEmail,
                                  "posts"
                                )
                              }
                              checked={postHasEmail}
                            />
                            <FormCheckbox
                              onChange={() =>
                                this.togglePref(
                                  user.id,
                                  "platform",
                                  postHasPlatform,
                                  "posts"
                                )
                              }
                              checked={postHasPlatform}
                            />
                          </div>
                          <div className="grid-col">
                            <FormCheckbox
                              onChange={() =>
                                this.togglePref(
                                  user.id,
                                  "email",
                                  alertHasEmail,
                                  "alerts"
                                )
                              }
                              checked={alertHasEmail}
                            />
                            <FormCheckbox
                              onChange={() =>
                                this.togglePref(
                                  user.id,
                                  "platform",
                                  alertHasPlatform,
                                  "alerts"
                                )
                              }
                              checked={alertHasPlatform}
                            />
                          </div>
                        </div>
                      );
                    })}
              </div>
            </Col>
          </Row>
          <br />
          <br />
          <br />
          <Row>
            <Col>
              <div className="notif-grid-table">
                <div className="notif-grid-table-headers">
                  <span>Special</span>
                </div>
                <div className="notif-grid-table-small-headers">
                  <span>Name</span>
                  <div className="grid-col">
                    <span>Email</span>
                    <span>Platform</span>
                  </div>
                </div>
                {this.state.preferences && (
                  <React.Fragment>
                    <div className="notif-grid-table-item">
                      <div className="table-user-data">Alerts I'm Tracking</div>
                      <div className="grid-col">
                        <FormCheckbox
                          checked={alertsImTrackingHasEmail}
                          onChange={() =>
                            this.changeAlertsImTracking(
                              "email",
                              alertsImTrackingHasEmail
                            )
                          }
                        />
                        <FormCheckbox
                          checked={alertsImTrackingHasPlatform}
                          onChange={() =>
                            this.changeAlertsImTracking(
                              "platform",
                              alertsImTrackingHasPlatform
                            )
                          }
                        />
                      </div>
                    </div>
                    <div className="notif-grid-table-item">
                      <div className="table-user-data">
                        Publisher Comment Replies
                      </div>
                      <div className="grid-col">
                        <FormCheckbox
                          checked={publisherPostRepliesHasEmail}
                          onChange={() =>
                            this.changePostReplies(
                              "email",
                              publisherPostRepliesHasEmail
                            )
                          }
                        />
                        <FormCheckbox
                          checked={publisherPostRepliesHasPlatform}
                          onChange={() =>
                            this.changePostReplies(
                              "platform",
                              publisherPostRepliesHasPlatform
                            )
                          }
                        />
                      </div>
                    </div>
                  </React.Fragment>
                )}
              </div>
            </Col>
          </Row>
        </Card>
      </React.Fragment>
    );
  }
}

export default NotificationsTab;
